const getRoot = state =>
  state.__KNOWLEDGEBASE.reports.articleFeedbackReducer

export const getArticleFeedbackData = state =>
  getRoot(state).articleFeedback